import * as React from 'react';
import { capitalize } from 'lodash';

import TextBadge, { TextBadgeColor, TextBadgeTextColor } from 'components/TextBadge';

export type BadgeMap = {
  [k: string]: {
    textColor: TextBadgeTextColor;
    color: TextBadgeColor;
  };
};

type Props = {
  content: string;
  color: TextBadgeColor;
  textColor: TextBadgeTextColor;
};

function TextBadgeCell({ content, color, textColor }: Props) {
  return (
    <TextBadge textSize="xxxxsmall" textWeight="normal" textColor={textColor} color={color}>
      {capitalize(content)}
    </TextBadge>
  );
}

export function getTextBadgeCellGenerator<T>(fieldName: keyof T, badgeMap: BadgeMap) {
  return (data: T) => {
    const content = (data[fieldName] as unknown) as string;

    if (!content) {
      return <span />;
    }

    return (
      <TextBadgeCell
        content={content}
        textColor={badgeMap[content] ? badgeMap[content].textColor : 'white'}
        color={badgeMap[content] ? badgeMap[content].color : 'eclipse'}
      />
    );
  };
}
